var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcViewDetails = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 12,
  fill: "none",
  viewBox: "0 0 16 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#3C97AA",
  strokeWidth: 2,
  d: "m1 10.474 5-4.737L1 1m8 9.474 5-4.737L9 1"
})));
export { SvgIcViewDetails as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxNiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNMSAxMC40NzM2TDYgNS43MzY3OUwxIDAuOTk5OTQ5TTkgMTAuNDczNkwxNCA1LjczNjc5TDkgMC45OTk5NDkiIHN0cm9rZT0iIzNDOTdBQSIgc3Ryb2tlLXdpZHRoPSIyIiAvPgo8L3N2Zz4=";